import image from '../../../../../img/icons/opt-if4health-halfsize.png';

export default function Banner(){
    return(
        <>
            <a name="sobre">
                <header>
                    <img className="img-fluid mx-auto" src={image} alt="logomarca if4health IFSul"/>
                </header>
            </a>
        </>
    );
}